/***
 *
 *   TICKET CONVERSATION STYLES
 *   The feed itself. The scroll container and composer belong to details.js.
 *
 **********/

const Style = {
    wrapper: 'flex min-h-0 flex-col',

    stickyBar: `sticky top-0 z-20 flex flex-wrap items-center gap-3 border-y border-border
        bg-background/95 px-4 py-2.5 backdrop-blur supports-[backdrop-filter]:bg-background/80
        sm:px-6`,
    barTitle: 'flex items-center gap-2 text-sm font-semibold text-text-primary',

    tabs: `ml-auto inline-flex items-center gap-0.5 rounded-lg border border-border bg-surface p-0.5`,
    tab: `inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium
        transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
    tabActive: 'bg-primary-600 text-white shadow-sm',
    tabIdle: 'text-text-secondary hover:bg-muted/70',
    tabCount: 'rounded-full bg-muted px-1.5 text-[10px] font-semibold tabular-nums text-text-muted',
    tabCountActive: 'bg-white/20 text-white',

    feed: 'space-y-3 px-4 pb-6 pt-4 sm:px-6',
    group: 'space-y-1',

    divider: 'flex items-center gap-3 py-1',
    dividerRule: 'h-px flex-1 bg-border',
    dividerLabel: `rounded-full border border-border bg-surface px-2.5 py-0.5 text-[11px]
        font-medium uppercase tracking-wide text-text-muted`,

    list: 'm-0 list-none p-0',
    item: 'relative pl-12',
    connector: 'absolute bottom-0 left-5 top-11 w-px -translate-x-1/2 bg-border',
    node: `absolute left-0 top-0 z-[1] flex h-10 w-10 items-center justify-center rounded-full
        bg-background`,
    eventNode: `flex h-7 w-7 items-center justify-center rounded-full border border-border
        bg-surface text-text-muted`,

    empty: `flex flex-col items-center justify-center rounded-xl border border-dashed border-border
        bg-surface/40 px-6 py-12 text-center`,
    emptyIcon: 'mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-muted/60',
    emptyText: 'max-w-sm text-sm text-text-secondary',
};

export default Style;
